(function() {
    'use strict';

    angular.module('itxApp.catalog').factory('CatalogUrlService', ItxCategorySvc);

    ItxCategorySvc.$inject = [
       '$rootScope'
    ];


    function ItxCategorySvc(
        $rootScope) {

        var _this = this;

        function initialStateCategory(category) {            
            _this.arrayState.push({
                isCategory: true,
                category: category
            });
            var url = category.getUrl();
            //REPLACE PARAMS..
            history.replaceState({}, 'category' + category.id, document.location.href);
        }

        function initialStateProduct(product) {
           
            var url = product.getUrl();
            _this.arrayState.push({
                isCategory: false,
                product: product
            });
            history.replaceState({}, 'product' + product.id, document.location.href);

        }

        function changeStateCategory(category) {
           
            _this.arrayState.push({
                isCategory: true,
                category: category
            });
            var url = category.getUrl();

            history.pushState({}, 'category' + category.id, url);
            $rootScope.$emit('categoryCtrl:loadCategory', category);
        }

        function changeStateProduct(product) {

            var productHistoryData = {};
            var url = product.getUrl();
            $rootScope.$emit('categoryCtrl:loadProduct', product);
            var prevElem = _.last(_this.arrayState);
            if (!prevElem.isCategory) {
                history.replaceState(productHistoryData, 'product' + product.id, url);
                _this.arrayState.pop();
            } else {
                history.pushState(productHistoryData, 'product' + product.id, url);
            }
            _this.arrayState.push({
                isCategory: false,
                product: product
            });
        }

        function init() {
            _this.arrayState = [];
            window.onpopstate = function(event) {
                if (event && event.state) {
                    processHistoryState(event.state);
                }
            };
        }

        function processHistoryState() {

            _this.arrayState.pop();
            var nextElement = _.last(_this.arrayState);
            if (!nextElement) {
                return history.back();
            }

            if (nextElement.isCategory) {
                $rootScope.$emit('categoryCtrl:loadCategory', nextElement.category);
            } else {
                $rootScope.$emit('categoryCtrl:loadProduct', nextElement.product.id);
            }
        }

        function back() {
            window.history.back();
        }
        return {
            init: init,
            changeStateProduct: changeStateProduct,
            changeStateCategory: changeStateCategory,
            initialStateProduct: initialStateProduct,
            initialStateCategory: initialStateCategory,
            back: back
        };
    }

})();